module.exports = __webpack_public_path__ + "static/media/Northridge-Farms-bylaws.6967baa0.pdf";